/**
 * Route Labels
 *
 * Maps route segments to translation keys in the 'nav' namespace.
 * Used in breadcrumbs and navigation menus.
 *
 * Note: These are now translation keys, not hardcoded labels.
 * Use with: t('nav.dashboard'), t('nav.detect'), etc.
 */

export const ROUTE_LABELS: Record<string, string> = {
  '': 'dashboard',
  'dashboard': 'dashboard',
  'detect': 'detect',
  'history': 'history',
  'projects': 'projects',
  'solutions': 'knowledgeBase',
  'contractors': 'contractors',
  'tickets': 'tickets',
  'email-templates': 'emailTemplates',
  'billing': 'billing',
  'settings': 'settings',
  'system-settings': 'systemSettings',
  'admin': 'admin',
  'users': 'users',
  'ai-training': 'aiTraining',
  'konzept': 'konzept',
  'inspections': 'inspections',
  'floorplan': 'floorplan',
  'board': 'board',
  'new': 'new',
} as const

/**
 * Get translation key for a route path segment
 * @deprecated Use t(`nav.${ROUTE_LABELS[segment]}`) instead
 */
export function getRouteLabel(segment: string): string {
  return ROUTE_LABELS[segment] || segment.charAt(0).toUpperCase() + segment.slice(1)
}
